import Link from '@/components/ui/Link'

import { cn } from '@/lib/utils'

export default function SectionFooter({
  icon,
  text,
  link,
  linkText,
  className,
}: {
  icon?: React.ReactNode
  text: string
  link?: string
  linkText?: string
  className?: string
}) {
  return (
    <div
      className={cn('flex flex-col items-center justify-center gap-4 py-10 sm:flex-row', className)}
    >
      {icon && (
        <div className="flex h-6 w-8 items-center justify-center rounded-full border border-gray-200 bg-gray-100">
          {icon}
        </div>
      )}
      <div className="flex flex-col items-center sm:flex-row sm:gap-1">
        <p
          dangerouslySetInnerHTML={{ __html: text }}
          className="text-balance text-center text-14 leading-normal text-zinc-500 [&>span]:font-semibold [&>span]:text-gray-950"
        />
        {link && (
          <Link href={link} className="underlined primary text-14">
            {linkText}
          </Link>
        )}
      </div>
    </div>
  )
}
